import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=a034a140&scoped=true"
import script from "./AdminProducts.vue?vue&type=script&lang=js"
export * from "./AdminProducts.vue?vue&type=script&lang=js"
import style0 from "./AdminProducts.vue?vue&type=style&index=0&id=a034a140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a034a140",
  null
  
)

export default component.exports